import React from 'react';
import { Button } from '@material-ui/core';
import clsx from 'clsx';
import classes from './ActionButton.module.scss';

const ActionButton = ({ leftIcon, className, ...props }) => {
  return (
    <Button {...props} className={clsx(classes.actionButton, className)} startIcon={leftIcon} />
  );
};
export default ActionButton;
